export default "__VITE_ASSET__BC23uc00__"